import * as React from "react";
import { Text as MantineText } from "@mantine/core";
import styled from "styled-components";
const StyledMantineText = styled(MantineText)`
  line-height: 1.25;
`;
const Text = ({ ...props }) => /* @__PURE__ */ React.createElement(StyledMantineText, { ...props });
export default Text;
